import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ethers } from "ethers";
import { formatEther } from "ethers/lib/utils";
import axios from "axios";

import toast from "react-hot-toast";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material";
import {
	Card,
	CardBody,
	Col,
	Button,
	Label,
	Input as InputStrap,
} from "reactstrap";

import { parse } from "papaparse";
import {
	createAtributes,
	getFileTypeMime,
	validateCSV,
	getMimeFromExt,
	getContractAbi,
	mintBatchERC721APSI,
} from "../../utils";
import {
	getUploadLink,
	pinFileIPFS,
	pinJSONArr,
	pinJSONIPFS,
	updataUnlock,
} from "../../hooks";
import { saveToken } from "../../store/actions/token";

import MintBatchErrorTab from "./MintBatchErrorTab";
import MintBatchTab from "./MintBatchTab";

import abiERC721 from "../../constants/sourceContract/abi/abiERC721.json";
import abiERC1155 from "../../constants/sourceContract/abi/abiERC1155.json";
import ConfirmBatchMintModal from "./ConfirmBatchMintModal";
import { useWeb3React } from "@web3-react/core";

const InputAsset = styled("input")({
	display: "none",
});

const BatchMintComponent = ({
	userId,
	handleChange,
	isBatchMint,
	ownPinata,
	contractItem,
	account,
	signer,
	setShow,
	setStage,
	setError,
	hideModal,
}) => {
	const dispatch = useDispatch();
	const history = useHistory();

	const { isOwnPinata, userPinataAPIKey, userPinataAPISecret } = useSelector(
		(state) => state.user.user
	);
	const [uploadFile, setUploadFile] = useState(null);
	const [batchList, setBatchList] = useState({});
	const [batchError, setBatchError] = useState([]);

	const [openActionModal, setOpeActionnModal] = useState(false);
	const handleCloseActionModal = () => {
		setOpeActionnModal(false);
	};

	useEffect(() => {
		if (batchList && batchList.data?.length > 0) {
			validateCSV(batchList.data, contractItem.type, setBatchError);
		}
	}, [batchList, contractItem]);

	const uploadAsset = (event) => {
		setBatchError([]);
		setUploadFile("");
		setBatchList({});
		let file = event.target.files[0];
		const fileType = getFileTypeMime(file.type, file.name);
		setUploadFile(file.name);
		if (!!file) {
			if (fileType !== "csv") {
				toast.error(`This file type is not supported`);
			} else {
				toast.success(`Uploud file ${uploadFile}, size ${file.size}b`);
				parse(file, {
					header: true,
					complete: function (results) {
						setBatchList(results);
					},
				});
			}
		}
	};

	const cancelUploadButton = () => {
		setUploadFile(null);
		setBatchList({});
		setBatchError([]);
	};

	const batchMintDataCreator = async (item) => {
		let meta = { unlockableLink: "" },
			unlockID;
		let { imageHash, thumbnail } = await pinFileIPFS(
			item["Link to content"],
			true,
			null,
			"tmp",
			ownPinata ? userId : "main"
		);
		const extension = item["Link to content"].split(".").at(-1);
		meta.description = item["Description"];
		if (item["Lockable content"] === "yes") {
			meta.digitalKey = {};
			meta.digitalKey.value = item["Lockable link"];
			const params = {
				account,
				digitalKey: meta.digitalKey.value,
				fileName: "",
				contentType: "text",
			};
			let { _id, addPath } = await getUploadLink(params);
			meta.external_url = `${process.env.REACT_APP_API_UNLOCK}/${addPath}`;
			meta.unlockableLink = addPath;
			unlockID = _id;
		}
		meta.name = item["Token Name"];
		meta.amount = item["Amount"];
		meta.price = item["Price"];
		meta.seller_fee_basis_points = Number(item["Royalties"]) * 100;
		item["Royalty Wallet"] === "Self"
			? (meta.fee_recipient = account)
			: (meta.fee_recipient = item["Royalty Wallet"]);

		meta.attributes = createAtributes(item);
		meta.image = "ipfs://ipfs/" + imageHash;
		meta.imageType = getMimeFromExt(extension);
		let tokenData = { ...meta };
		// tokenData.description = item["Description"];
		// tokenData.unlockableLink = meta.unlockableLink;
		delete meta.digitalKey;
		delete meta.unlockableLink;
		const hashMetaToken = await pinJSONIPFS(meta);
		tokenData.metadataLink = hashMetaToken;
		tokenData.contractId = contractItem._id;
		tokenData.image = imageHash;
		tokenData.thumbnail = thumbnail;
		tokenData.royalties = item["Royalties"];

		return {
			token: tokenData,
			meta: hashMetaToken,
			metaImplicit: meta,
			amount: tokenData.amount,
			unlockId: unlockID,
		};
	};

	const batchMinting = async () => {
		setShow(true);
		setStage("upload");

		let batchTokenArray = [];
		let batchMintArray = [];
		let batchMintArrayImplicit = [];
		let batchAmountArray = [];
		let batchUnlockIdArray = [];

		let tokenResponce;
		const mint = async () => {
			let abi = getContractAbi(contractItem.type);
			const contract = new ethers.Contract(contractItem.address, abi, signer);
			if (contractItem.type === "ERC721" || contractItem.type === "ERC721UPG") {
				const gas = await contract.estimateGas
					.mintBatch(
						batchMintArray
						// [],
						// "0x0000000000000000000000000000000000000000000000000000000000000000"
					)
					.catch((err) => {
						console.log(err);
						return "1200000";
					});

				tokenResponce = await contract
					.mintBatch(
						batchMintArray,
						// [],
						// "0x0000000000000000000000000000000000000000000000000000000000000000",
						{
							gasLimit: gas,
						}
					)
					.catch(() => {
						return null;
					});
			} else if (
				contractItem.type === "ERC1155" ||
				contractItem.type === "ERC1155UPG"
			) {
				const gas = await contract.estimateGas
					.mintBatch(batchAmountArray, 0, batchMintArray)
					.catch((err) => {
						console.log(err);
						return "1200000";
					});

				tokenResponce = await contract
					.mintBatch(batchAmountArray, 0, batchMintArray, { gasLimit: gas })
					.catch(() => {
						return null;
					});
			} else if (["ERC721A", "ERC721PSI"].includes(contractItem.type)) {
				const { tx } = await mintBatchERC721APSI(
					contract,
					account,
					batchMintArrayImplicit
				);

				tokenResponce = tx;
			}

			if (!tokenResponce) {
				await hideModal();
				return;
			}

			if (tokenResponce === 1) {
				setStage("done");
				await hideModal();
				return;
			}

			const tokenTxn = await tokenResponce.wait();
			const totalBatchGas = (
				tokenTxn.effectiveGasPrice.toNumber() *
				parseFloat(formatEther(tokenTxn.gasUsed._hex))
			).toFixed(8);

			setStage("done");
			await hideModal();

			const tokenIDArray = [];

			for (let i = 0; i < tokenTxn.events.length; i++) {
				const event = tokenTxn.events[i];
				if (event.event?.toLowerCase() !== "transfer") continue;
				const tokenId = ethers.BigNumber.from(event.args.tokenId).toNumber();
				tokenIDArray.push(tokenId);
			}

			// if (contractItem.type === "ERC721" || contractItem.type === "ERC721UPG") {
			// 	for (let i = 0; i < tokenTxn.events.length; i++) {
			// 		const event = tokenTxn.events[i];
			// 		if (event.event?.toLowerCase() !== "transfer") continue;
			// 		const tokenId = ethers.BigNumber.from(event.args.tokenId).toNumber();
			// 		tokenIDArray.push(tokenId);
			// 	}
			// } else if (
			// 	contractItem.type === "ERC1155" ||
			// 	contractItem.type === "ERC1155UPG"
			// ) {
			// 	for (let i = 1; i < tokenTxn.events.length; i++) {
			// 		// let tokenId = Number.parseInt(tokenTxn.events[i].args.tokenId._hex);
			// 		const tokenId = ethers.BigNumber.from(event.args.tokenId).toNumber();

			// 		tokenIDArray.push(tokenId);
			// 	}
			// }

			if (batchUnlockIdArray.some((item) => item !== undefined)) {
				for (let i = 0; i < batchUnlockIdArray.length; i++) {
					if (batchUnlockIdArray[i] !== undefined) {
						updataUnlock(
							batchUnlockIdArray[i],
							tokenIDArray[i],
							contractItem.address,
							contractItem.type
						);
					}
				}
			}

			for (let i = 0; i < batchTokenArray.length; i++) {
				let newToken = { ...batchTokenArray[i] };
				newToken.tokenID = tokenIDArray[i];
				newToken.gas =
					Math.trunc((totalBatchGas / batchTokenArray.length) * 100000000) /
					100000000;
				dispatch(saveToken(newToken));
			}
		};

		try {
			for (const item of batchList.data) {
				if (item.no && item["Token Name"] && item["Link to content"]) {
					let { token, meta, metaImplicit, amount, unlockId } =
						await batchMintDataCreator(item);
					batchTokenArray.push(token);
					batchMintArray.push(meta);
					batchMintArrayImplicit.push(metaImplicit);
					batchAmountArray.push(Number.parseInt(amount));
					batchUnlockIdArray.push(unlockId);
				}
			}

			setStage("mint");

			// console.log(batchList);

			await mint();

			history.push(`/contracts/${contractItem._id}`);
		} catch (error) {
			setError({ message: error.message });
			await hideModal();
		}
	};

	return (
		<>
			<Col>
				<ConfirmBatchMintModal
					open={openActionModal}
					handleClose={handleCloseActionModal}
					submit={batchMinting}
				/>
				<Card>
					<CardBody>
						<h1 style={{ textAlign: "center" }}>Batch mint tokens</h1>
						<div className="d-inline-flex justify-content-left align-items-center mb-3 flex-wrap">
							<Label
								htmlFor="isBatchMint"
								style={{
									cursor: "pointer",
									fontSize: "14px",
								}}
							>
								Batch minting
							</Label>
							<div className="form-switch mb-2 ps-0">
								<InputStrap
									style={{
										marginLeft: "8px",
										marginTop: 0,
										width: "45px",
										cursor: "pointer",
									}}
									type="switch"
									name="isBatch"
									checked={isBatchMint}
									disabled={!isBatchMint}
									onChange={handleChange}
									id="isBatchMint"
									aria-label="controlled"
								/>
							</div>
						</div>
						<Tooltip
							title={
								!userPinataAPIKey || !userPinataAPISecret
									? "Please specify your Pinata API Gateway credentials in your profile to use this feature"
									: ""
							}
						>
							<div>
								{isOwnPinata && (
									<div className="d-flex justify-content-left align-items-center mb-3">
										<Label
											htmlFor="isOwnPinata"
											style={{
												cursor: "pointer",
												fontSize: "14px",
											}}
										>
											Use my Pinata
										</Label>

										<div className="form-switch mb-2 ps-0">
											<InputStrap
												style={{
													marginLeft: "8px",
													marginTop: 0,
													width: "45px",
													cursor: "pointer",
												}}
												type="switch"
												name="isOwnPinata"
												checked={ownPinata}
												disabled={!userPinataAPIKey || !userPinataAPISecret}
												onChange={handleChange}
												id="isOwnPinata"
												aria-label="controlled"
											/>
										</div>
									</div>
								)}
							</div>
						</Tooltip>

						{ownPinata && (
							<Typography
								sx={{
									mb: "2rem",
									letterSpacing: "0.00938em",
									color: "#808080",
									fontFamily: "Montserrat",
									fontSize: "14px",
									lineHeight: "20px",
								}}
							>
								Metadata of your token(s) will be uploaded on IPFS using your
								Pinata API Gateway credentials. To review API credentials please
								go to your profile page
							</Typography>
						)}

						<Box sx={{ m: "1rem 0" }}>
							<Typography
								className="form-label"
								sx={{
									width: "100%",
									fontFamily: "Montserrat",
									fontStyle: "normal",
									fontWeight: "normal",
									fontSize: "13px",
									lineHeight: "24px",
								}}
								component="span"
							>
								Please use the following CSV template to specify token's
								details:
								<Typography
									component="a"
									sx={{
										display: "inline-block",
										fontFamily: "Montserrat",
										fontStyle: "normal",
										fontWeight: "normal",
										fontSize: "13px",
										lineHeight: "24px",
										ml: "1rem",
									}}
									download
									href={
										contractItem.type === "ERC721"
											? "https://ec-spaces.fra1.digitaloceanspaces.com/templates/template_batch_single-token.csv"
											: "https://ec-spaces.fra1.digitaloceanspaces.com/templates/template_batch_multi-token.csv"
									}
								>
									Download template
								</Typography>
							</Typography>
						</Box>

						<Typography
							className="form-label"
							sx={{
								width: "100%",
								fontFamily: "Montserrat",
								fontStyle: "normal",
								fontWeight: "normal",
								fontSize: "17px",
								lineHeight: "24px",
							}}
							component="p"
						>
							Upload file
						</Typography>
						<Card
							style={{
								position: "relative",
								display: "flex",
								justifyContent: "center",
								flexWrap: "wrap",
								width: "100%",
								borderRadius: "16px",
								padding: "2rem 3.5rem",
								margin: "2rem 0",
							}}
						>
							{uploadFile && (
								<Button
									color="primary"
									style={{
										position: "absolute",
										top: "0.5rem",
										right: "0.5rem",
										width: "40px",
										minWidth: "40px",
										height: "40px",
										border: "1px solid #07ED63",
										borderRadius: "50%",
										color: "##040405",
									}}
									onClick={cancelUploadButton}
								>
									x
								</Button>
							)}
							<Typography
								mb="1rem"
								className="form-label"
								sx={{
									fontFamily: "Montserrat",
									width: "100%",
									textAlign: "center",
								}}
								component="p"
							>
								{uploadFile
									? `You choose file: ${uploadFile}`
									: "Need correcty CSV file"}
							</Typography>
							{!uploadFile && (
								<Label
									for="input-batch"
									style={{
										textAlign: "center",
									}}
								>
									<InputAsset
										accept={".csv"}
										id="input-batch"
										type="file"
										onChange={uploadAsset}
									/>
									<Button
										color="primary"
										tag="span"
										variant="outlined"
										disabled={!!uploadFile}
									>
										Choose file
									</Button>
								</Label>
							)}
						</Card>
						<Card style={{ padding: "6px 2px" }}>
							{batchError && batchError.length !== 0 ? (
								<MintBatchErrorTab item={batchError} />
							) : (
								<Typography
									className="form-label"
									sx={{
										fontFamily: "Montserrat",
										padding: "0.5rem",
										textAlign: "center",
									}}
									component="p"
								>
									Not Error
								</Typography>
							)}
						</Card>
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
							}}
						>
							<Button
								color="primary"
								disabled={batchError.length > 0}
								onClick={() => setOpeActionnModal(true)}
								style={{
									width: "192px",
									margin: "1rem auto 0",
								}}
							>
								Start batch mint
							</Button>
						</Box>
					</CardBody>
				</Card>
			</Col>
			<Col md={5} style={{ minWidth: "min-content" }}>
				<Card>
					<CardBody>
						<h4>Preview</h4>
						{uploadFile ? (
							<MintBatchTab list={batchList} />
						) : (
							<Card
								style={{
									display: "flex",
									flexWrap: "wrap",
									justifyContent: "center",
									alignItems: "center",
									width: "100%",
									minHeight: "260px",
									maxHeight: "85vh",
									overflow: "auto",
									borderRadius: "16px",
									padding: "14px",
									margin: "2rem 0",
								}}
							>
								<h6 style={{ textAlign: "center" }}>
									Upload csv file to preview
								</h6>
							</Card>
						)}
					</CardBody>
				</Card>
			</Col>
		</>
	);
};

export default BatchMintComponent;
